import React from 'react';
import styled from 'styled-components';
import KoffieBackButton from './KoffieBackButton';

const t = {
  bg: '#f2f0eb', white: '#ffffff', text: '#0c0c0b',
  muted: '#8a8780', lines: '#dcd9d1', accent: '#c75a0a',
  sans: "'Jost', system-ui, sans-serif",
  serif: "'Playfair Display', Georgia, serif",
};

const Wrap = styled.div`
  height: 100%; width: 100%; background: ${t.bg};
  overflow-y: auto; -webkit-overflow-scrolling: touch;
`;

const Page = styled.div`
  padding: 36px 40px 80px; max-width: 480px; margin: 0 auto;
  @media (max-width: 600px) { padding: 24px 20px 64px; }
`;

const PageTitle = styled.h1`
  font-family: ${t.serif}; font-size: clamp(20px, 3vw, 26px);
  font-weight: 900; color: ${t.text}; letter-spacing: -0.02em;
  margin: 0 0 20px;
`;

const InfoBanner = styled.div`
  display: flex; align-items: flex-start; gap: 10px;
  padding: 12px 14px; border-radius: 6px; margin-bottom: 24px;
  background: rgba(199,90,10,0.06); border: 1px solid rgba(199,90,10,0.2);
  font-family: ${t.sans}; font-size: 12px; line-height: 1.6; color: ${t.text};
`;

const SectionLabel = styled.div`
  font-family: ${t.sans}; font-size: 10px; font-weight: 500;
  letter-spacing: 0.16em; text-transform: uppercase;
  color: ${t.muted}; margin-bottom: 8px;
`;

const Card = styled.div`
  background: ${t.white}; border: 1px solid ${t.lines};
  border-radius: 8px; overflow: hidden;
`;

const Row = styled.div`
  display: flex; align-items: center; padding: 12px 16px; gap: 12px;
  border-bottom: 1px solid ${t.lines};
  &:last-child { border-bottom: none; }
`;

const RowLabel = styled.div`
  font-family: ${t.sans}; font-size: 11px; font-weight: 500;
  color: ${t.muted}; min-width: 72px;
`;

const RowValue = styled.div`
  font-family: ${t.sans}; font-size: 13px; color: ${t.text}; flex: 1;
`;

const AccentLink = styled.a`
  color: ${t.accent}; text-decoration: none; font-family: ${t.sans}; font-size: 13px;
  &:hover { text-decoration: underline; }
`;

export default function KoffieLegal() {
  return (
    <Wrap>
      <Page>
        <KoffieBackButton to="/Koffiereparatie/settings" />
        <PageTitle>Wettelijke documentatie</PageTitle>

        <InfoBanner>
          <span>
            Je bent ingelogd bij <strong>Koffiereparatie Geleen</strong>. Dit is een op maat gemaakt project. De documentatie kan afwijken van de standaardvoorwaarden van Webvonk. Neem contact op voor meer informatie.
          </span>
        </InfoBanner>

        <SectionLabel>Contactgegevens</SectionLabel>
        <Card>
          <Row>
            <RowLabel>Platform</RowLabel>
            <RowValue>Mijn Webvonk v2.0</RowValue>
          </Row>
          <Row>
            <RowLabel>E-mail</RowLabel>
            <RowValue><AccentLink href="mailto:info@webvonk.com">info@webvonk.com</AccentLink></RowValue>
          </Row>
          <Row>
            <RowLabel>Website</RowLabel>
            <RowValue><AccentLink href="https://webvonk.com" target="_blank" rel="noreferrer">webvonk.com</AccentLink></RowValue>
          </Row>
        </Card>
      </Page>
    </Wrap>
  );
}
